import * as React from "react";
import { CheckboxEditor } from "../../../react-core/Html/CheckboxEditor";
import { TaskRequestStatus } from "../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";
import { DocumentTaskRequestModel } from "../../../Wrap/Models/Models/Tasks/DocumentTaskRequestModel";
import { DocumentFileAction } from "../../Dashboard/Components/Clients/PortfolioDashboard/Components/Document/Action/DocumentFileAction";
import { IProcessComponentProps, ProcessComponent } from "../Process/Process/ProcessComponent";
import AriaTooltip from "../Tooltip/AriaTooltip";
import { DownloadButtonAction } from "./Actions/DownloadButtonAction";

interface IMultiDownloadButtonProps extends IProcessComponentProps {
    request?: DocumentTaskRequestModel;
    selectedAccount: string;
    callBack?: (val) => void;
    isSelectedAll: boolean;
    triggerred: number;
    fileName: string;
    trigger?: (callback) => void;
    triggerAuto?: boolean;
    tooltip?: string | JSX.Element;
    isDisabled?: boolean;
}

interface IMultiDownloadButtonState {
    isPending?: boolean;
    isCompleted?: boolean;
    isFailed?: boolean;
    taskRequestId?: number;
    fileName?: string;
    url?: string;
    isSelected?: boolean;
}
export class MultiDownloadButton extends ProcessComponent<IMultiDownloadButtonProps, IMultiDownloadButtonState> {
    constructor(props: any) {
        super(props);
        this.state = { isPending: false, isCompleted: false, isSelected: false };
    }

    componentDidMount(): void {
        super.componentDidMount();
        if (this.props.triggerAuto) {
            this.trigger();
        }
    }

    private setTimeout;

    componentWillUnmount() {
        clearInterval(this.setTimeout);
    }

    componentWillReceiveProps(nextProps: Readonly<IMultiDownloadButtonProps>, nextContext: any): void {
        if (nextProps.isSelectedAll != this.props.isSelectedAll) {
            if (nextProps.isSelectedAll && this.state.isPending) {
            } else {
                this.setState({ isSelected: nextProps.isSelectedAll });
            }
        }
        if (
            nextProps.triggerred != this.props.triggerred &&
            this.state.isSelected &&
            !this.props.triggerAuto &&
            this.props.isDisabled !== false
        ) {
            this.trigger();
            this.setState({ isSelected: false });
        }
    }

    private trigger() {
        this.setState({ isPending: true, isCompleted: false, isFailed: false });
        if (this.props.trigger) {
            this.props.trigger((requestId, fileName) => {
                this.setState(
                    {
                        taskRequestId: requestId,
                        fileName: fileName,
                        isPending: true,
                        isCompleted: false,
                        isFailed: false,
                    },
                    () => {
                        this.getStatus(requestId);
                    }
                );
            });
        } else {
            this.triggerDefault();
        }
    }

    private onStatusChange(status: TaskRequestStatus) {
        if (
            status == TaskRequestStatus.Pending ||
            status == TaskRequestStatus.Running ||
            status == TaskRequestStatus.Allocated ||
            status == TaskRequestStatus.PendingDelayed ||
            status == TaskRequestStatus.PendingHold
        ) {
            this.setTimeout = setTimeout(() => {
                DownloadButtonAction.getTaskRequestStatus(this.state.taskRequestId.toString(), (callback) =>
                    this.onStatusChange(callback.Status)
                );
            }, 2000);
        } else if (status == TaskRequestStatus.Complete) {
            if (this.props.callBack) {this.props.callBack(this.state.taskRequestId);}
            const hierarchyId = this.props.selectedAccount == null ? "" : this.props.selectedAccount;
            DocumentFileAction.get(
                hierarchyId,
                this.state.fileName,
                true,
                0,
                this.state.taskRequestId,
                this.props.request.ClAccountId,
                (result: string) => {
                    this.setState({
                        isPending: false,
                        isCompleted: true,
                        isFailed: false,
                        url: result,
                    });
                }
            );
        } else {
            this.setState({ isFailed: true, isPending: false, isCompleted: false });
        }
    }

    private triggerDefault() {
        this.setState({ isPending: true, isCompleted: false });
        DownloadButtonAction.addTaskRequestForDocument(this.props.request, (data) => {
            this.setState(
                {
                    taskRequestId: data?.TaskRequestID,
                    fileName: data?.FileName,
                    isPending: true,
                    isCompleted: false,
                    isFailed: false,
                },
                () => this.getStatus(data?.TaskRequestID)
            );
        });
    }

    private getStatus(requestId) {
        if (requestId == undefined) {return;}
        DownloadButtonAction.getTaskRequestStatus(requestId.toString(), (callback) =>
            this.onStatusChange(callback.Status)
        );
    }

    public render(): JSX.Element {
        const option = {
            label: "",
            disabled: this.state.isPending || this.props.triggerAuto || this.props.isDisabled === false,
            value: !this.props.triggerAuto || this.props.isDisabled !== false ? this.state.isSelected : false,
            onChange: (v) => {
                this.setState({ isSelected: v });
            },
        };
        return (
            <div>
                <CheckboxEditor {...option} cssWrapper={"square-checkbox"} />
                <span
                    className={this.state.isCompleted ? "hyperlink" : null}
                    onClick={() => {
                        if (this.state.isCompleted) {
                            window.open(this.state.url, "_blank");
                        }
                    }}
                >
                    {this.props.fileName}
                </span>
                {this.props.tooltip && (
                    <span>
                        <AriaTooltip cssWrapper="is-info-icon" showCloseButton={true}>
                            {this.props.tooltip}
                        </AriaTooltip>
                    </span>
                )}
                <>
                    {this.state.isPending && <span className="lds-dual-ring"></span>}
                    {this.state.isFailed && <span> Failed</span>}
                    {this.state.isCompleted && (
                        <span>
                            <button
                                type="button"
                                className="download-button label-sr-only ml-20"
                                onClick={() => {
                                    window.open(this.state.url, "_blank");
                                }}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="sr-only">Download</span>
                            </button>
                        </span>
                    )}
                </>
            </div>
        );
    }
}
